import PhaseFive from "components/Rater/CompleteSelfServey/SurveyPhase/PhaseFive"
import React from "react"

const PhaseFivePage = () => {
    return (
        <React.Fragment>
            <PhaseFive />
        </React.Fragment>
    )
}
export default PhaseFivePage
